// extracted by mini-css-extract-plugin
export var details = "_gr-0";
export var inspectorPopover = "_gr-1";